import { render, staticRenderFns } from "./right-bottom.vue?vue&type=template&id=9d8837d0&"
import script from "./right-bottom.vue?vue&type=script&lang=js&"
export * from "./right-bottom.vue?vue&type=script&lang=js&"
import style0 from "./right-bottom.vue?vue&type=style&index=0&id=9d8837d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports